import { platformRole } from "@/app/registry";
import { useSession } from "@/app/session";

import { useAccess } from "./planAccess";

/** What the role card says under the logo. */
export function useRoleCard(): { title: string; sub: string; active: boolean } {
  const { user } = useSession();
  const access = useAccess();
  const role = platformRole(user?.role);
  if (role === "admin") return { title: "Admin", sub: "Full access", active: true };
  if (role === "employee") return { title: "Employee", sub: "Sales", active: true };
  if (access?.kind === "ra_client" || user?.ra_client)
    return {
      title: "RA client",
      sub: access?.ra_name
        ? `Client of ${access?.ra_name}`
        : "Your analyst's calls",
      active: access?.active !== false,
    };
  const plan =
    access?.plan_name ?? (role === "ra" ? "Research Analyst" : "Investor");
  const sub = !access
    ? ""
    : !access.active
      ? "Plan not active"
      : access.kind === "trial"
        ? `Free trial · ${access.days_left ?? 0} days left`
        : access.kind === "complimentary"
          ? `Complimentary · ${access.days_left ?? 0} days left`
        : access.days_left != null
          ? `${access.days_left} days left`
          : "Active";
  return { title: plan, sub, active: access?.active !== false };
}

/** How the "View as this user" banner (V044) names the viewed account. */
export function viewRoleLabel(user: {
  role: string;
  access_tier?: string | null;
  ra_client?: boolean | null;
}): string {
  const role = platformRole(user.role);
  if (role === "ra") return "Research Analyst";
  if (role === "employee") return "Employee";
  if (role === "admin") return "Admin";
  return user.access_tier === "client" || user.ra_client
    ? "RA client"
    : "Investor";
}
